import { useAppSelector } from '@@/auto/hooks/redux';
import {
  getAutoQuote as selectAutoQuote,
  getUrlParams,
} from '@@/auto/store/selectors';
import { useConfig } from '@@/common/services/useConfig';

import TenantPhoneLink, { TTenantPhoneLink } from './TenantPhoneLink';

export default function TenantPhoneLinkForTenant(
  props: Omit<TTenantPhoneLink, 'phoneNumber'>
) {
  const {
    config: { tenantPhoneNumber = '', utmSourceTenantPhoneNumberMap = {} },
  } = useConfig();

  const quote = useAppSelector(selectAutoQuote);
  const urlParams = useAppSelector(getUrlParams);

  const utmSource = (
    quote?.application.metadata.utm_source ||
    (urlParams?.ti_ref as string) ||
    (urlParams?.utm_source as string) ||
    ''
  ).toLowerCase();

  const phoneNumber =
    utmSourceTenantPhoneNumberMap[utmSource] || tenantPhoneNumber;

  return <TenantPhoneLink phoneNumber={phoneNumber} {...props} />;
}
